import { render, staticRenderFns } from "./AuditRecordsTab.vue?vue&type=template&id=e0550d4a&scoped=true&"
import script from "./AuditRecordsTab.vue?vue&type=script&lang=js&"
export * from "./AuditRecordsTab.vue?vue&type=script&lang=js&"
import style0 from "./AuditRecordsTab.vue?vue&type=style&index=0&id=e0550d4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0550d4a",
  null
  
)

export default component.exports